import React, { useState, useEffect } from 'react';
import { getHousekeeperExt } from '../api/housekeeperApi';
import './SalaryFlowPage.css';

// 解析 bank_card_url（JSON 数组或单个 URL）
const parseBankCardUrls = (raw) => {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw.filter((u) => u);
  try {
    const parsed = JSON.parse(raw);
    if (Array.isArray(parsed)) return parsed.filter((u) => u);
  } catch (e) { /* 非 JSON，按单个 URL 处理 */ }
  return [raw];
};

// 数字转中文（>=1）
const cnNumber = (n) => {
  const digits = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
  if (n <= 9) return digits[n];
  if (n === 10) return '十';
  if (n < 20) return `十${digits[n % 10]}`;
  const tens = Math.floor(n / 10);
  const ones = n % 10;
  let s = `${digits[tens]}十`;
  if (ones > 0) s += digits[ones];
  return s;
};

export default function SalaryFlowPage({ id, navigateTo }) {
  const [images, setImages] = useState([]);
  const [previewUrl, setPreviewUrl] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await getHousekeeperExt(id);
        const urls = parseBankCardUrls(res.data && res.data.bank_card_url);
        if (!cancelled) {
          setImages(urls.map((u, i) => ({ url: u, label: `第${cnNumber(i + 1)}张` })));
        }
      } catch (e) {
        if (!cancelled) alert('加载失败');
      }
    })();
    return () => { cancelled = true; };
  }, [id]);

  return (
    <div className="salary-flow-page">
      <div className="salary-flow-title">薪资流水及银行卡信息</div>
      <div className="salary-flow-content">
        {images.length === 0 && <div className="salary-flow-empty">暂无薪资流水</div>}
        {images.map((it, i) => (
          <div key={i} className="salary-flow-item">
            <div className="salary-flow-label">{it.label}</div>
            <img className="salary-flow-img" src={it.url} alt={it.label} onClick={() => setPreviewUrl(it.url)} />
          </div>
        ))}
      </div>
      <div className="action-bar">
        <button className="action-btn" onClick={() => navigateTo('detail', { id })}>返回</button>
      </div>

      {previewUrl && (
        <div className="image-preview-overlay" onClick={() => setPreviewUrl('')}>
          <img className="image-preview-img" src={previewUrl} alt="预览" onClick={(e) => e.stopPropagation()} />
        </div>
      )}
    </div>
  );
}